export default {
    data() {
      return {
        Reqfields: {
          Representative: [
            "Full Name",
            "ID Number",
            "Designation",
            "Nationality",
          ],
          "Senior Management": ["Full Name", "Designation", "Nationality"],
          Shareholder: [
            "Full Name",
            "ID Number",
            "Designation",
            "Nationality",
            "No of Shares",
          ],
          "Board of directors": ["Full Name", "ID Number", "DOB", "Nationality"],
          "List of Board of partners": [
            "Full Name",
            "ID Number",
            "DOB",
            "Nationality",
          ],
          Settlor: ["First Name", "Last Name", "ID Number", "DOB", "Nationality"],
          "The Protector": ["Full Name", "ID Number", "DOB", "Nationality"],
          Owner: ["First Name", "Last Name", "ID Number", "DOB", "Nationality"],
          "List of Office bearer and appointed Committee member": [
            "Full Name",
            "ID Number",
            "DOB",
            "Nationality",
          ],
        },
      };
    },
    methods: {
      getRequired(val) {
        let keys = Object.keys(this.Reqfields);
        let requiredOtp = [];
        keys.map((ele) => {
          if (val.includes(ele)) {
            requiredOtp = [...requiredOtp, ...this.Reqfields[`${ele}`]];
          }
        });
        return requiredOtp.filter(
          (item, index) => requiredOtp.indexOf(item) === index
        );
      },
    },
  };
  